export default __webpack_public_path__ + "static/media/Wild.a4a582c3.png";